import { APP_MINI_GAMES_WIN_ID, USER_SESSION_TOKEN } from '@common/constants';
import config from '@config';
import { reactLocalStorage } from 'reactjs-localstorage';

export const handleMiniGamesParams = (searchParams: URLSearchParams) => {
  const winId = searchParams.get('win_id');
  if (winId) {
    sessionStorage.setItem(APP_MINI_GAMES_WIN_ID, winId);
  }
};

export const miniGamesClaimWin = async (userId: number) => {
  const winId = sessionStorage.getItem(APP_MINI_GAMES_WIN_ID);
  const token = reactLocalStorage.get<string | undefined>(USER_SESSION_TOKEN);
  if (!winId || !token || !config.miniGamesHost) {
    return;
  }
  const response = await fetch(`${config.miniGamesHost}/api/games/claim`, {
    method: 'POST',
    body: JSON.stringify({
      user_id: userId,
      win_id: winId,
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (response.status === 404 || response.status === 409 || response.ok) {
    sessionStorage.removeItem(APP_MINI_GAMES_WIN_ID);
  }
  return response.status;
};
